// removed by extract-text-webpack-plugin
module.exports = {"redirectText":"style__redirectText___1NIxH","redirectWrapper":"style__redirectWrapper___devdb"};


//////////////////
// WEBPACK FOOTER
// ./components/Redirect/style.scss
// module id = ./components/Redirect/style.scss
// module chunks = 5